module.exports = __webpack_public_path__ + "images/marketing/hero2.jpg";